export const ARTIST_BODY_TEXT =
  "Looks like your artist profile hasn't been completely setup. Let's finish that step now!";
export const FAN_BODY_TEXT =
  "Looks like your fan profile hasn't been completely setup. Let's finish that step now!";
export const PROFILE_BUTTON_TEXT = 'Create your profile';
export const SESSION_BODY_TEXT =
  "Looks like you haven't created your first session. Let's do that now!";
export const SESSION_BUTTON_TEXT = 'Create your first session';
export const TITLE = 'Ooops!';
export const FINISH_SETTING_UP =
  "It appears you haven't verified your email yet, please click below to receive a new code";
export const VERIFICATION_BUTTON_TEXT = 'Resend Code';
export const WELCOME_BACK_HEADER = 'Welcome Back!';
